module.exports = __webpack_public_path__ + "img/3.a859d7bd.jpg";